import React from 'react';
import debounce from 'lodash/debounce';
import ImgIconComp from '../../imgcomp';
import OKRHeaderComp from './okr-header';
import CascadeObjective from './cascade-okr';
import GoalServices from '../../../services/goal.services';
import { uniqueArrayObject } from '../../../utils/function';
import LoaderComp from '../../helper/loader';
import { withTranslation } from 'react-i18next';
import {ThemeProvider,Button} from '@workboard/wobo-ui'
import { KeyDownEvent } from '../../../utils/eventKey';
import './update-kr-view.styles.scss'
import { krdetailConstants } from '../../../constants/krdetails.constants';
import { useKrUpdateValidation } from '../../../resources/krUpdateValidationProvider';
import { Skeleton } from '@mui/material';

class ReloadComponent {
  setReloadHash;

  reload = () => {
    if (!this.setReloadHash) return;
    this.setReloadHash(null);
    const hash = Math.random().toString(36).substring(7);
		this.setReloadHash(hash);
  }
}
const reloadComponent = new ReloadComponent();
const murationObserver = new MutationObserver((mutation) => {
  let shouldDetroyCKEditor = false;
  mutation.forEach((m) => {
    m.addedNodes.forEach((n) => {
      if (n.classList && n.classList.contains('cke')) {
        n.remove();
        shouldDetroyCKEditor = true;
      }
    });
    if (shouldDetroyCKEditor && 'CKEDITOR' in window) {
	    window.CKEDITOR.disableAutoInline = true;
      for (const instance in window.CKEDITOR.instances) {
        window.CKEDITOR.instances[instance].destroy();
      }
    }
  });
  if (shouldDetroyCKEditor) {
    reloadComponent.reload();
  }
});

class UpdateKRContainer extends React.Component {
	constructor(props) {
		super(props);
		const {userKrs=[]} = this.props.goalsData;
		this.state = {
			showEmoticon: false,
			selMdId: null,
			initialFormHash: null,
			userKrs,
			loading: false,
			scrolling: true,
			hashLoader: '09lkj4'
		};
		this.showEmoticonList = this.showEmoticonList.bind(this);
		this.hashDiff = this.hashDiff.bind(this);
		this.convertSerializedArrayToHash = this.convertSerializedArrayToHash.bind(this);
		this.handleBodyClick = this.handleBodyClick.bind(this);
		this.goalDetPage = this.goalDetPage.bind(this);
		this.krsDetDetPage = this.krsDetDetPage.bind(this);
		this.submitKrData = this.submitKrData.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
		this.delayCallback = debounce(this.handleScroll, 300);
		this.getOffset = this.getOffset.bind(this);
		this.fetchingMoreData = this.fetchingMoreData.bind(this);
		this.triggerRedirectGoalPage = this.triggerRedirectGoalPage.bind(this);

		this.callRequest = false;
		this.GoalServices = new GoalServices();
		this.initPendoVisitorReport = this.initPendoVisitorReport.bind(this);
	}


	componentDidMount() {
		this.initPendoVisitorReport();
		this._isMounted = true;
		window.addEventListener('click', this.handleBodyClick, true);
		const $form = $('#metricDataSubmit');
		const initialFormHashVal = this.convertSerializedArrayToHash($form.serializeArray());
		const _this = this;

		/* This section is needed to fully get rid of CKEditor instances */
		murationObserver.observe(document.body, {
			childList: true,
		});
		reloadComponent.setReloadHash = (hash) => {
			this.setState({
				hashLoader: hash
			})
		}
		/* End */
		setTimeout(() => _this.setState({
			initialFormHash: initialFormHashVal,
		}), 10);
		$('#metricDataSubmit:first *:input[type!=hidden]:first').focus();
		window.addEventListener('scroll', this.delayCallback, false);
		setTimeout(() => {
			// prevent auto inline --> Ckeditor is intitialized on contenteditable by default
			CKEDITOR.disableAutoInline = true;
		}, 0);
		const focusEl = document.getElementById('skip-link-nav')
		if (focusEl) focusEl.focus();
	}

	componentWillUnmount() {
		this._isMounted = false;
		window.removeEventListener('click', this.handleBodyClick, true);
		window.removeEventListener('scroll', this.delayCallback, false);
		murationObserver.disconnect();
		reloadComponent.setReloadHash = null;
	}

	handleScroll() {
		const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
		const body = document.body;
		const html = document.documentElement;
		const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
		const windowBottom = windowHeight + window.pageYOffset;
		let ele = document.querySelector('#update-krs-view');
		if (ele && this._isMounted && windowBottom >= (docHeight - 500) && this.state.scrolling) {
			this.fetchingMoreData();
		}
	}

	getOffset() {
		return this.state.userKrs.reduce((preVal, current) => preVal+= parseInt(current.metrics.length), 0);
	}

	fetchingMoreData() {
		if (this.callRequest)
			return;
		this.callRequest = true;
		var reqCall = (this.props.goalsData.req_call) ? this.props.goalsData.req_call : '';
		let params = {};
		params.offset = this.getOffset();
		params.json = 1;
		if (params.offset >= 20) {
			this.setState({
				loading: true
			});
			this.GoalServices.getMyUpdateKRs(params, reqCall)
				.then( response => {
					this.callRequest = false;
					let userKrs = this.state.userKrs;
					let scrolling = false;
					var resUserKrs = {};
					if(response.data.userKrs){
						resUserKrs = response.data.userKrs; //updateMyKr Request response
					}else if(response.data.updateKeyResults.userKrs){
						resUserKrs = response.data.updateKeyResults.userKrs; //updateKrs Request response
					}
					if (resUserKrs) {
						scrolling = resUserKrs.length ? true : false;
						resUserKrs.map(okr => {
							let findOKR = userKrs.find(k => k.id == okr.id);
							if (findOKR) {
								findOKR.metrics = uniqueArrayObject([...findOKR.metrics, ... okr.metrics], 'id');
							}
							else {
								userKrs.push(okr);
							}
						});
						this.setState({
							userKrs,
							loading: false,
							scrolling
						});
					}
				});
		}
	}

	showEmoticonList(mdId) {
		this.setState({
			showEmoticon: true,
			selMdId: mdId,
        }, () => {
            const isTabbing = document.body.classList.contains('is-tabbing');
            if (isTabbing) {
                setTimeout(() => {
                    document.body.classList.add('is-tabbing');
                })
            }
            document.querySelector(`#emoticon-list-container-${mdId} .emojiWrapper`)?.focus();
        });
	}

	hashDiff(h1, h2) {
		const d = {};
		for (const k in h2) {
			if (h1[k] !== h2[k]) d[k] = h2[k];
		}
		return d;
	}

	convertSerializedArrayToHash(a) {
		const r = {};
		for (let i = 0; i < a.length; i++) {
			r[a[i].name] = a[i].value;
		}
		return r;
	}

	handleBodyClick(e) {
		if (!$('.smiley-container').is(e.target) // if the target of the click isn't the container...
			&& $('.smiley-container').has(e.target).length === 0) {
			this.setState({
				showEmoticon: false,
			});
		}
	}

    hideEmoticonList = () => {
        const { selMdId } = this.state;
        this.setState({
            showEmoticon: false,
        }, () => {
            document.getElementById(`emoji-picker-${selMdId}`)?.focus();
        });
    }

	goalDetPage(goalId, metricId = null, hasAccess = true, parentMId = 0) {
		const params = {};
		params.id = goalId;
		const searchParams = new URLSearchParams(window.location.search);

		if (metricId != null) {
			params.metricId = metricId;
		}
		if (parentMId) {
			return viewCascadeMetric(params.metricId);
		}
		if (hasAccess) {
			if(metricId != null){
				window.wb_track('OKR_ACTION', {
					location: searchParams.get('location') || '',
					locationDetail: searchParams.get('locationDetail') || '',
					objectAction: 'VIEW',
					object: 'KEY_RESULT',
					objectDetail: 'KEY_RESULT_PAGE',
					objectId: metricId,
				});
				return metricDetailsPage(metricId,'',true);
			}

			window.wb_track('OKR_ACTION', {
				location: searchParams.get('location') || '',
				locationDetail: 'Objectives_I_Own',
				objectAction: 'VIEW',
				object: 'OBJECTIVE',
				objectDetail: 'OKR_POPUP',
				objectId: goalId,
			});
			return viewGoalDetailsPage(undefined, params);
		}
	}

	krsDetDetPage(goalId) {
		return loadUpdateKrsPage('1');
	}

	triggerRedirectGoalPage() {
		const queryString = window.location.search;
		const referrerSource = new URLSearchParams(queryString).get('refSrc');
		const goalsUrl = `${wbConfig.baseUrl}/goal/index`;
		if (window.isVnextPage()) {
			if (referrerSource === 'OLP') {
				window.location.href = `${wbConfig.baseUrl}/okrs`;
			} else {
				return triggerLeftMenu(goalsUrl, 'menu-wb-goals', undefined);
			}
		}
		if (updateKeyResultsMenu && updateKeyResultsMenu != '') {
			const goalsUrl = $(updateKeyResultsMenu).attr('data-url');
			triggerLeftMenu(goalsUrl, updateKeyResultsMenu, undefined);
		} else {
			const goalsUrl = $('#menu-wb-goals').attr('data-url');
			triggerLeftMenu(goalsUrl, 'menu-wb-goals', undefined);
		}
	}

	submitKrData() {
		// console.log('submitKrData');
		const searchParams = new URLSearchParams(window.location.search);
		window.wb_track('OKR_ACTION', {
			location: searchParams.get('location') || '',
			locationDetail: searchParams.get('locationDetail') || '',
			object: 'KEY_RESULT',
			objectId: '',
			objectAction: 'UPDATE_ACCESSED',
		});
		const $formVal = $('#metricDataSubmit');
		const serFormVal = $formVal.serializeArray();
		if ($.ajaxSetup().data.YII_CSRF_TOKEN) {
			serFormVal.push({ name: 'YII_CSRF_TOKEN', value: $.ajaxSetup().data.YII_CSRF_TOKEN });
		}
		if (typeof event_source_from !== 'undefined') {
			serFormVal.push({ name: 'event_source_from', value: event_source_from });
		}
		const currentItems = this.convertSerializedArrayToHash(serFormVal);
		const initialFormHashVal = this.state.initialFormHash;
		let itemsToSubmit = '';
		if (initialFormHashVal) {
			itemsToSubmit = this.hashDiff(initialFormHashVal, currentItems);
		} else {
			itemsToSubmit = $formVal.serializeArray();
		}
		const { userKrs } = this.state;
		const validationErrors = [];
		userKrs.forEach((goal) => goal.metrics.forEach((kr) => {
			const confidence = document.querySelector(`[name="metric[${kr.id}][${kr.metricLastData.id}][confidence]"]`)?.value
			const narrative = document.querySelector(`[name="metric[${kr.id}][${kr.metricLastData.id}][cmt]"]`)?.value
			const showNewKrUpdateUX = window.wbConfig?.isConfidenceOnKrUpdatesEnabled && kr?.source == krdetailConstants.SOURCE_PERSON
			const requireNarrativeError = showNewKrUpdateUX && Number(confidence ?? -1) > -1 && !narrative

			if(requireNarrativeError) {
				validationErrors.push({
					field: 'cmt',
					updateId: kr.metricLastData?.id,
					errorMsg: 'Narrative is required when confidence is selected'
				})
			}
		}))

		this.props.setErrors(validationErrors)		
		if(validationErrors?.length > 0) return

		showLoaderWidget($('#content'));
		const userKrsLength = Array.isArray(userKrs) ? userKrs.length : 0;
		this.setState({
			scrolling: false
		});
		this.GoalServices.saveUserKr(itemsToSubmit)
			.then((response, status) => {
				removeLoader();
				const { data } = response.data;
					let updateKrTargetHit = [];
					if (typeof data === 'object' && response != '') {
						data.map((item, index) => {
							if (item.progress >= 100 && item.stop_update == 1 && item.progress_consider == 1) {
							if (userKrsLength) {
								for(let i = 0; i < userKrsLength; i++) {
									if (Array.isArray(userKrs[i].metrics) && userKrs[i].metrics.length) {
										const findMetric = userKrs[i].metrics.find(m => m.id == item.id);
										if (findMetric) {
											updateKrTargetHit.push({
												id: findMetric.id,
												name: findMetric.name
											});
											break;
							}
									}
								}
							}
						}
						});
					}
					if (!window.wbConfig?.isCloseKeyResultEnabled && updateKrTargetHit.length > 0) {
					openKRStopUpdateModal({
						metricId: updateKrTargetHit[0].id,
						goalName: updateKrTargetHit[0].name,
						source: 'fullUpdate',
						updateKrTargetHit,
					});
				} else {
					this.triggerRedirectGoalPage();
					}
			})
			.catch(err => {
				console.log('error', err);
				this.triggerRedirectGoalPage();
			});
	}

	handlePrevPage = () => {
    	const searchParams = new URLSearchParams(window.location.search);
		const referrerSource = searchParams.get('refSrc');

		if (referrerSource === 'OLP') {
        	window.history.pushState('', '', `${location.origin}/wb/okrs`);
			window.dispatchEvent(new Event('popstate'));
		} else {
			window.history.pushState('', '', `${location.origin}`);
			window.dispatchEvent(new Event('popstate'));	
		}
	}

	initPendoVisitorReport() {
		if (this.props.goalsData?.isPendoEnabled) {
			window.trackPendoVisitorReport?.();
		}
	}

	render() {
		let {
			handEmoji={},
			symbolEmoji={},
			pplEmoji={},
			getAllOkrs,
			userKrsCount,
			cascadeList,
      setTeamObjevtiveBool,
      display_kr_confidence,
		} = this.props.goalsData;
		const goalListData = this.state.userKrs || [];
		const goalListLength = goalListData.length;
		getAllOkrs = getAllOkrs || 0;
		userKrsCount = userKrsCount || 0;
		cascadeList = cascadeList || {};
		setTeamObjevtiveBool = setTeamObjevtiveBool || 0;
		// console.log("setTeamObjevtiveBool 2 "+setTeamObjevtiveBool);
		const allOkrClassName = (getAllOkrs == 1) ? 'updateKRMinData' : 'updateKRFullData';
		const {t} = this.props;
		if (this.state.hashLoader === null) {
			return (
				<Skeleton variant="rectangular" width="100%" height="50px" />
			)
		}
		return (
			<div id="update-krs-view" className="update-krs-view-due-page">
				{(getAllOkrs == 0)
					&& (
						<>
							<span
								tabIndex={0}
								role="button"
								className="back-btn-arrow"
								aria-label="back"
								onClick={this.handlePrevPage}
								onKeyDown={(e) => {
									KeyDownEvent(e, () => this.handlePrevPage())
								}}
								style={{position: "absolute", top:"26px", left: "21px"}}
							>
								<i className="back-btn-arrow-icon clickable"></i>
							</span>
							<span className="updateKRHeading" role="heading" aria-level="1">
							{t('Update Key Results')}
							</span>
						</>
					)
				}
				{
					(getAllOkrs == 1 && userKrsCount > 0)
					&& (
						<div className="updateKRFullLink clickable" onClick={() => this.krsDetDetPage()}>
							<ImgIconComp class="clickable updateKRMetricUpdImg" id="metric_upd_img_new" width="12" height="12" />
                         &nbsp;&nbsp;{t('Update')}
							{' '}
							<span className="colorRed">{userKrsCount}</span>
							{' '}
							{t('now')}
						</div>
					)
				}
				{
					cascadeList != null
					&& (
						<div className="cascadeObjectiveKrList">
                            <CascadeObjective
                                key='cascadeobjectives'
                                cascadeList={cascadeList}
                                goalDetPage={this.goalDetPage}
                                setTeamObjevtiveBool={setTeamObjevtiveBool}
                            />
						</div>
					)
				}
				<form id="metricDataSubmit" key="metric_data_12345">
					<div className={allOkrClassName}>
						{
							(goalListLength)
								? goalListData.map((item, index) => (
									<div className="updateKRGoalContainer" key={index}>
                      <OKRHeaderComp
                          key={'okrheader-' + item.id}
                          item={item}
                          goalDetPage={this.goalDetPage}
                          handEmoji={handEmoji}
                          symbolEmoji={symbolEmoji}
                          pplEmoji={pplEmoji}
                          showEmoticonList={this.showEmoticonList}
						  hideEmoticonList={this.hideEmoticonList}
                          selMdId={this.state.selMdId}
                          showEmoticon={this.state.showEmoticon}
                          getAllOkrs={getAllOkrs}
                          displayKRConfidence={display_kr_confidence}
                      />
									</div>
								))
								: (
									<div className="updateKREmptyGoalContainer">
										{t("No KR's available for update.")}
									</div>
								)
						}
						{
							(goalListLength && getAllOkrs == 0)
								?
								<>
									<div className='updateKRActionContainer'>
										<ThemeProvider className='test-flas'>
												<Button
													variant="primary"
													onClick={this.submitKrData}
													data-testid="update-btn-updateKR-due"
												>
													{t('Update')}
												</Button>
												<Button onClick={this.handlePrevPage} style={{marginLeft: '16px'}}>{t('Cancel')}</Button>
										</ThemeProvider>
									</div>
									{this.state.loading && <LoaderComp />}
								</>
								: ''
						}
					</div>
				</form>
			</div>
		);
	}
}

const withKrUpdateValidation = (Component) => ((props) => {
	const { setErrors } = useKrUpdateValidation()

	return (
		<Component {...props} setErrors={setErrors}/>
	)
})

export default withTranslation()(withKrUpdateValidation(UpdateKRContainer))
